<template>
  <div>
    <doe-label :name="name" :required="fieldRequired">
      {{ label }}
    </doe-label>
    <span v-if="prefix" class="absolute border-gray-800 border-r font-sans leading-snug py-2 subpixel-antialiased font-bold text-center text-black text-xl max-w-xs w-full">{{ prefix }}</span>
    <select
      :disabled="dynamicDisabledVal"
      autocomplete="off"
      :key="name"
      :name="name"
      :id="name"
      v-validate="validation"
      :data-vv-as="fieldNameInErrorMessage || label"
      :class="{ hasError: errors.has(name), hasPrefix: prefix }"
      :aria-describedby="generateAriaDescription(name)"
      @change="$emit('input', $event.target.value)"
    >
      <option value="">Select an option</option>
      <option v-for="(option, index) in options" :key="index" :value="option.value" :selected="option.value === value">{{ option.text }}</option>
    </select>
    <doe-error v-if="errors.has(name)" :description="ariaErrorDescID(name)">{{ errors.first(name) }}</doe-error>
    <doe-hint :hint="hint" :description="ariaDescID(name)" />
  </div>
</template>

<script>
import dynamicValues from "@/mixins/dynamicValues";
import DoeLabel from "@/components/field/Label";
import DoeHint from "@/components/field/Hint";
import DoeError from "@/components/field/Error";

export default {
  name: "DoeDropdown",
  inject: {
    $validator: "$validator"
  },
  mixins: [ dynamicValues ],
  props: {
    options: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: String
    },
    label: {
      type: String,
      required: true
    },
    fieldNameInErrorMessage: {
      type: String
    },
    fieldRequired: {
      type: Boolean,
      default: false
    },
    prefix: {
      type: String
    },
    validation: {
      type: [Object, String]
    },
    hint: {
      type: [Array, String]
    },
    dynamicDisable: {
      type: [Boolean, Function],
      default: false
    },
  },
  components: {
    DoeLabel,
    DoeHint,
    DoeError
  },
  computed: {
    dynamicDisabledVal(){
      return this.getDisabledValue(this.dynamicDisable);
    }
  },
  methods: {
    generateAriaDescription(fieldName) {
      if (this.errors.has(fieldName)) {
        return this.ariaErrorDescID(fieldName);
      }
      if (this.hint) {
        return this.ariaDescID(fieldName);
      }
      return false;
    },
    ariaDescID(fieldName) {
      return `${fieldName}Description`;
    },
    ariaErrorDescID(fieldName) {
      return `${fieldName}ErrorDescription`;
    },
  }
};
</script>

<style lang="scss" scoped>
select {
  @apply bg-gray-300 border border-gray-800 rounded font-sans leading-snug max-w-2xl px-3 py-2 subpixel-antialiased text-gray-900 text-xl w-full;
  &:hover {
    @apply border-blue-900;
    box-shadow: 0 0 0 1px #041e42;
  }
  &:focus {
    @apply border-blue-900;
    box-shadow: 0 0 0 1px #041e42;
    outline: 1px solid #041e42;
    outline-offset: 3px;
  }
  &:disabled {
    background: #e5e5e5;
    border: 1px solid #666 !important;
  }
}
</style>
